import Component from '@glimmer/component';

export default class MwAboutFeatures extends Component {
}
